module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAICAYAAACCuR0hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAB2SURBVDiN1ZKxDYRAEANnT7SBSC+AHo7K4Ctj6YGA9J9CloQY9nWgE5Pash1YfrGbgMQ70MowBbTwEBcB5tIb/kY8puM2j2KYNuvyufIFb1j2ogsESU93FMF1CQ/f2A5neoC5XhfN7alyAwC22CZDxnOX9Xd07XpxGnzRVS+IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/card.png
// module id = jGmc
// module chunks = 1